// directives/globalTooltip.js
let globalTooltipInstance = null
let currentEl = null

export const globalTooltip = {
  mounted(el, binding) {
    el.tooltipConfig = typeof binding.value === 'object' ? binding.value : { content: binding.value }

    el.addEventListener('mouseenter', handleMouseEnter)
    el.addEventListener('mouseleave', handleMouseLeave)

    el._tooltipEnterHandler = handleMouseEnter
    el._tooltipLeaveHandler = handleMouseLeave
  },

  updated(el, binding) {
    el.tooltipConfig = typeof binding.value === 'object' ? binding.value : { content: binding.value }
  },

  unmounted(el) {
    el.removeEventListener('mouseenter', el._tooltipEnterHandler)
    el.removeEventListener('mouseleave', el._tooltipLeaveHandler)

    if (currentEl === el) {
      hideTooltip()
    }
  },
}

export function setGlobalTooltipInstance(instance) {
  globalTooltipInstance = instance
}

function handleMouseEnter(event) {
  currentEl = event.currentTarget
  const config = currentEl.tooltipConfig

  if (!config.content) return

  globalTooltipInstance.virtualRef = currentEl

  globalTooltipInstance.content = config.content
  globalTooltipInstance.visible = true
}

function handleMouseLeave() {
  globalTooltipInstance.visible = false
}

function hideTooltip() {
  handleMouseLeave()
}
